import { RefObject, useEffect, useMemo, useState } from 'react';

/**
 * Use on screen
 */
const useOnScreen = (ref: RefObject<HTMLElement>) => {
  const [isIntersecting, setIntersecting] = useState(false);

  const observer = useMemo(
    () =>
      typeof window !== 'undefined'
        ? new IntersectionObserver(
            ([entry]) => setIntersecting(entry.isIntersecting),
            {
              threshold: 0.9
            }
          )
        : null,
    [ref]
  );

  useEffect(() => {
    observer?.observe(ref.current);

    return () => {
      observer?.disconnect();
      setIntersecting(false);
    };
  }, []);

  return isIntersecting;
};

export { useOnScreen };
